<template>
    <a href="#!"
       :data-override="url"
       data-theme="none"
       :class="{'hover:text-blue-500 hover:border-blue-600 hover:bg-white bg-blue-500 text-white': $page.props.current_subscription === plan,'text-blue-500 border-blue-600 hover:bg-blue-500 hover:text-white':$page.props.current_subscription !== plan}"
       class="inline-flex paddle_button cursor-pointer justify-center items-center whitespace-nowrap ring-blue-700 focus:outline-none transition-colors duration-150 border py-2 px-3 focus:ring rounded flex-1 mr-3 last:mr-0 mb-3"
       type="button">
        <span class="pl-2 pr-2">
        <slot/>
    </span>
    </a>
</template>

<script>
export default {
    name: "PaddleButton",
    props: {
        url: String,
        plan: String
    }
}
</script>

<style scoped>

</style>
